import { render, staticRenderFns } from "./notification-template-new-order-start.vue?vue&type=template&id=018b2dca&scoped=true"
import script from "./notification-template-new-order-start.vue?vue&type=script&lang=js"
export * from "./notification-template-new-order-start.vue?vue&type=script&lang=js"
import style0 from "./notification-template-new-order-start.vue?vue&type=style&index=0&id=018b2dca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018b2dca",
  null
  
)

export default component.exports